// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"1d323b8e","334":"da3c464d","447":"c875a72c","733":"2e18afd0","941":"70e87acb"}[chunkId] + ".chunk.css";
};